<template>
  <button
    ref="tooltipAnchorEl"
    v-bind="$attrs"
    class="text-black-1! flex items-center"
    :data-cy-value="`filter--${filtered ? `${filtered}` : 'inactive'}`"
    :disabled="disabled"
    :aria-label="sortLabel"
    :aria-describedby="clicks ? tooltipEl?.tooltipId : undefined"
    :class="{ 'cursor-default!': disabled }"
    @click.prevent="
      !disabled && emit('click', nextFilterType) && nextFilterType
        ? nextTick(() => tooltipEl?.show?.())
        : tooltipEl?.hide?.()
    "
    @focus="() => !disabled && tooltipEl?.show?.()"
    @mouseenter="() => !disabled && tooltipEl?.show?.()"
    @blur="() => !disabled && tooltipEl?.hide?.()"
    @mouseleave="() => !disabled && tooltipEl?.hide?.()"
  >
    <slot></slot>
    <span v-if="!disabled" class="relative -mt-0.5 self-stretch">
      <RfChevronMiniClosedIcon
        class="fill-beige-50 absolute top-1/2 mt-1 h-6! w-6! -translate-y-1/2"
        :class="{ 'opacity-50': filtered !== 'desc' }"
      />
      <RfChevronMiniOpenIcon
        class="fill-beige-50 absolute top-1/2 -mt-1 h-6! w-6! -translate-y-1/2"
        :class="{ 'opacity-50': filtered !== 'asc' }"
      />
    </span>
    <RfTooltip v-if="clicks" ref="tooltipEl" :anchor="tooltipAnchorEl">
      <template #tooltip>
        <div>Click {{ clicks.number }} more {{ clicks.text }} to clear</div>
      </template>
    </RfTooltip>
  </button>
</template>

<script setup>
import RfTooltip from "@/components/tooltip/RfTooltip.vue";
import { computed, nextTick, ref } from "vue";
import RfChevronMiniClosedIcon from "@/components/icons/RfChevronMiniClosedIcon.vue";
import RfChevronMiniOpenIcon from "@/components/icons/RfChevronMiniOpenIcon.vue";

const emit = defineEmits(["click"]);

const filterTypes = [null, "asc", "desc"];

const tooltipEl = ref();
const tooltipAnchorEl = ref();
const props = defineProps({
  filtered: { type: [String, null], default: null },
  disabled: { type: [Boolean, String], default: false },
});

const clicks = computed(() => {
  if (props.filtered === "asc") return { number: 2, text: "times" };
  if (props.filtered === "desc") return { number: 1, text: "time" };
  return null;
});

const nextFilterType = computed(() => {
  const index = filterTypes.findIndex(el => el === props.filtered);
  return filterTypes[index + 1] || filterTypes[0];
});

const sortLabel = computed(() => {
  if (props.filtered === "asc") return "Sort ascending";
  if (props.filtered === "desc") return "Sort descending";
  return "Not sorted";
});
</script>
